import React from "react";
export default class LetterPanel extends React.Component {
  render() {
    return <div className="letter-panel">{this.props.children}</div>;
  }
}
